import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useRouteHistory = () => {
  const [routeHistory, setRouteHistory] = useState([]);
  const { pathname } = useLocation();

  useEffect(() => {
    const pathParts = pathname.split('/');
    const isSearch = pathname.includes('/search');
    const route = pathParts[1];

    const lastPathname = !!routeHistory.length && routeHistory[0].pathname;

    if (pathname !== lastPathname) {
      setRouteHistory(
        [
          {
            pathname,
            route: isSearch ? 'search' : route,
          },
          ...routeHistory,
        ].splice(0, 5)
      );
    }
  }, [pathname, routeHistory]);

  return routeHistory;
};

export default useRouteHistory;
